import { render, staticRenderFns } from "./MyFirstCampaign.vue?vue&type=template&id=ba66b49a"
import script from "./MyFirstCampaign.vue?vue&type=script&lang=js"
export * from "./MyFirstCampaign.vue?vue&type=script&lang=js"
import style0 from "./MyFirstCampaign.vue?vue&type=style&index=0&id=ba66b49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports